module.exports = __webpack_public_path__ + "static/img/facebook03.2372c30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/social/facebook03.png
// module id = I7Xc
// module chunks = 0